import { Box, styled } from '@mui/material';
import * as React from 'react';

import { HF_ICON_SIZES } from '@root/app/shared/theme/designTokens';

export type ImageIconSize = keyof typeof HF_ICON_SIZES;

const getSize = (size: string): number => HF_ICON_SIZES[size as ImageIconSize] ?? HF_ICON_SIZES.xl;

type ImageIconProps = {
    size: ImageIconSize;
    alt?: string;
    sizeOverride?: number;
    src: string;
};

const ImageBox = React.forwardRef(function ImageBox(props, ref) {
    return <Box ref={ref} component='img' {...props} />;
});

const ImageIcon = styled(ImageBox)<ImageIconProps>(({ size, sizeOverride }) => ({
    height: sizeOverride ?? getSize(size)
}));

export { ImageIcon };
